import { Navigate } from 'react-router-dom'
import Loader from '../pages/Loader'

const UnverifiedRoute = ({user, isLoading, children}) => {
    if (isLoading) return <Loader />
    if (!user) return <Navigate to="/" />
    if (user.isAccountVerified) return <Navigate to="/dashboard" />
    return children
}

export default UnverifiedRoute